/* eslint-disable import/no-cycle */
import BaseModel from '@/utils/store/BaseModel'
import Collection from '@/store/models/collections/Collection'

class ResourceTag extends BaseModel {
  static entity = 'resourcetags'

  static fields() {
    return {
      ...super.fields(),
      name: this.string(),
      createdAt: this.attr(null),
      // relationships
      ownerId: this.attr(null),
      owner: this.belongsTo(Collection, 'ownerId'),
    }
  }
}

export default ResourceTag
